const { default: axiosIns } = require('@/libs/axios')

const CatalogSetsService = {
  // GET - CatalogSetApiController
  async getCatalogSets(catalogId, accountId) {
    return axiosIns.get(`/catalogs/${catalogId}/sets?accountId=${accountId}`).then(response => response.data)
  },
  async getCatalogSet(catalogId, catalogSetId, accountId) {
    return axiosIns.get(`/catalogs/${catalogId}/sets/${catalogSetId}?accountId=${accountId}`).then(response => response.data)
  },
  async getCatalogSetItems(catalogId, catalogSetId, page, accountId) {
    return axiosIns.get(`/catalogs/${catalogId}/sets/${catalogSetId}/items?page=${page}&accountId=${accountId}`).then(response => response.data)
  },
  async getCatalogSetItemsCount(catalogId, catalogSetId, accountId) {
    return axiosIns.get(`/catalogs/${catalogId}/sets/${catalogSetId}/itemscount?accountId=${accountId}`).then(response => response.data)
  },
  // POST - CatalogSetApiController
  async validateSet(catalogId, catalogSet, accountId) {
    return axiosIns.post(`/catalogs/${catalogId}/sets/validation?accountId=${accountId}`, catalogSet).then(response => response.data)
  },
  async createSet(catalogId, catalogSet, accountId) {
    return axiosIns.post(`/catalogs/${catalogId}/sets?accountId=${accountId}`, catalogSet).then(response => response.data)
  },
  // PUT - CatalogSetApiController
  async updateSet(catalogId, catalogSetId, catalogSet, accountId) {
    return axiosIns.put(`/catalogs/${catalogId}/sets/${catalogSetId}?accountId=${accountId}`, catalogSet).then(response => response.data)
  },
  // DELETE - CatalogSetApiController
  async deleteCatalogSet(catalogId, catalogSetId, accountId) {
    return axiosIns.delete(`/catalogs/${catalogId}/sets/${catalogSetId}?accountId=${accountId}`).then(response => response.data)
  },
}
export default CatalogSetsService
